import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';
import { SharedService } from '../../../../providers/shared.service';
import { StorageService } from '../../../../providers/storage.service';

@Component({
  selector: 'sm-razorpay-account-id-add',
  templateUrl: './razorpay-account-id-add.component.html',
  styleUrls: ['./razorpay-account-id-add.component.scss']
})
export class RazorpayAccountIdAddComponent implements OnInit, OnDestroy {
  addRazorpayAccountIdForm : FormGroup;

  addRazorpayHash:string = ''

  
  private apiSubscription: Subscription = new Subscription();
  constructor(private sharedService: SharedService,private storageService : StorageService ,public dialog: MatDialogRef<RazorpayAccountIdAddComponent>, private _apiservice: ApiService, private router: Router) { 
    this.addRazorpayAccountIdForm = new FormGroup({
     
      'razorpayAccountId' : new FormControl(null,[Validators.required]),
      
  });

 
  }



  ngOnInit(): void {
    
    this.addRazorpayHash =  this.storageService.getValueFromAppStorage('addRazorpay')

  // this.apiSubscription = this._apiservice.apiResult.subscribe((data) => {
  //   console.log(data);

  //   // UPDATE_BUSINESS_DOCS_STATUS_RESULT
   
    
   
  // })
  // console.log(this.entityList);


    


    
  }

  addStatusNotes(){
  console.log(this.addRazorpayAccountIdForm.value.razorpayAccountId);




    let data = { 
      hashId: this.addRazorpayHash,
      razorpay_account_id: this.addRazorpayAccountIdForm.value.razorpayAccountId 
      }
      console.log(data);

this._apiservice.updateBankInfo(data)
this.dialog.close();
setTimeout(() => {
  this.sharedService.sendClickEvent();
}, 2000);

  }


  public closePopup(): void {
    this.dialog.close();
  }

  ngOnDestroy(): void {
    this.apiSubscription.unsubscribe();
  }

}
